<template>
  <div class="c-select-monitor">
    <Button :type="type" :disabled="disabled" @click="monitorModal = true">
      <span v-if="len">更新规则</span>
      <span v-else>选择规则</span>
    </Button>
    <dl class="c-select-content">
      <template v-for="monitor in data">
        <dd class="c-butler" :key="monitor.id">
          <span>{{ monitor.name }}</span>
          <span v-show="!disabled" class="c-butler-del" @click="$emit('on-delete', monitor.id)">删除</span>
        </dd>
      </template>
    </dl>
    <!-- 智能自动化 -->
    <monitor
      v-model="monitorModal"
      :media="media"
      :open-id="openId"
      :selection="data"
      @on-cancel="monitorModal = false"
      @on-select="monitorSelect"
    ></monitor>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import Monitor from '@/components/monitor/manager.vue'
export default {
  name: 'selectMonitor',
  components: { Monitor },
  props: {
    data: {
      type: Array
    },
    media: {
      type: [Number, String]
    },
    openId: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    len() {
      return Boolean(this.data.length)
    },
    type() {
      return this.len ? 'default' : 'primary'
    }
  },
  methods: {
    monitorSelect(meta) {
      if (isArray(meta)) this.$emit('on-select', meta)
      this.monitorModal = false
    }
  },
  data() {
    return {
      monitorModal: null
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-monitor {
  position: relative;

  .c-select-content {
    font-size: 12px;
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    max-height: 268px;
    margin-bottom: 0;
  }

  .c-butler {
    span {
      display: inline-block;
      max-width: 380px;

      &.c-butler-del {
        margin-left: 20px;
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>
